<template>
    <div id="container">
      <div class="d-flex justify-content-between">
        <h4>Cost</h4>
          <div>
            <DxButton
              icon="download"
              hint="Download Cost excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshTableCost" />
          </div>
            <!-- b-button
              variant="outline-primary"
              size="sm"
              @click="refreshTableCost"
              >Refresh</b-button
            -->
      </div>
      <br />
      <div>
        <b-row align-h="end">
          <b-col cols="2">
            <p class="border border-info p-1">Total daily field cost: {{ sumFieldCostFormatted }}</p>
          </b-col>
          <b-col cols="2">
            <p class="border border-info p-1">Cumulated field cost : {{ cumFieldCostFormatted }}</p>
          </b-col>
        </b-row>
        <div style="height: 40px; display: flex; justify-content: right" >
          <DxButton
            :disabled="!editEligible"
            text="Clone"
            width="40"
            icon="copy"
            hint="Add a copy of the selected row" 
            styling-mode="outlined"
            @click="cloneRow"/>
          <DxButton
            :disabled="!editEligible"
            :width="40"
            icon="edit"
            hint="Edit field cost" 
            styling-mode="outlined"
            @click="editRow"/>
          <DxButton
            :disabled="!editEligible"
            :visible="!deleteWarning"
            :width="40"
            icon="trash"
            hint="Delete field cost" 
            styling-mode="outlined"
            @click="onDelete"/>
          <DxButton
            :disabled="!editEligible"
            :visible="deleteWarning"
            text="Confirm"
            width="150"
            icon="trash"
            hint="Confirm to delete" 
            styling-mode="outlined"
            @click="deleteRow"/>
          <DxButton
            :disabled="!editable"
            :width="40"
            icon="plus"
            hint="Add new cost" 
            styling-mode="outlined"
            @click="addRow"/>
        </div>
        <DxDataGrid
            id="cost-report-grid"
            :data-source="costData"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="false"
            :height="400"
            @row-click="onRowClick"
          >
          <!--  @selection-changed="onSelectionChanged"
          -->
            <DxSelection mode="single" />
            <DxEditing
              :allow-updating="false"
              :allow-adding="false"
              :allow-deleting="false"
              :use-icons="true"
              mode="row"
            />
            <DxPaging :enabled="true" :page-size="5" />
            <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>
            <DxColumn data-field="cbName" caption="Contract Bundle"/>
            <DxColumn data-field="cgcName" caption="General Component"/>
            <DxColumn data-field="ciName" caption="Cost Item"/>
            <DxColumn data-field="description" caption="Cost Description" />
            <DxColumn data-field="serviceCompany" caption="Service Company" />
            <DxColumn data-field="qty" data-type="number" caption="Qty" />
            <DxColumn data-field="costAmount" data-type="number" caption="Cost Amount" format="currency" />
        </DxDataGrid>

        <DxPopup
          :visible="popupVisible"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          :show-close-button="false"
          :show-title="true"
          :width="600"
          :height="600"
          :position="{ my: 'center', at: 'center', of: 'window' }"
          container="body"
          :title="popUpTitle"
        >          
          <DxPosition
            at="bottom"
            my="center"
            of="positionOf"
            collision="fit"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="saveButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptions"
          />
          <div class="dx-fieldset">
            <div class="dx-field">
              <label for="ccbSelect" class="dx-field-item-label">Contract Bundle</label>
              <div class="dx-field-value">
                  <DxSelectBox
                    v-model="newFieldCost.cbId"
                    name="ccbSelect"
                    :data-source="optionsComboContractBundle"
                    display-expr="text"
                    value-expr="cbId"
                    label="Contract Bundle"
                    label-mode="hidden"
                    @value-changed="onChangeContractBundle"
                    />
              </div>
            </div>
            <div class="dx-field">
              <label for="cgcSelect" class="dx-field-item-label">General Component</label>
              <div class="dx-field-value">
                <DxSelectBox
                  v-model="newFieldCost.cgcId"
                  name="cgcSelect"
                  :data-source="optionsComboGeneralComponent"
                  display-expr="text"
                  value-expr="cgcId"
                  label="General Component"
                  label-mode="hidden"
                  label-location="top"
                  :disabled="!(newFieldCost.cbId > 0)"
                  @value-changed="onChangeGeneralComponent"
                  />
                </div>
            </div>
            <div class="dx-field">
              <label for="ciSelect" class="dx-field-label">Cost Item</label>
              <div class="dx-field-value">
                <DxSelectBox
                  v-model="newFieldCost.ciId"
                  name="ciSelect"
                  :data-source="optionsComboCostItem"
                  display-expr="text"
                  value-expr="ciId"
                  label="Cost Item"
                  label-mode="hidden"
                  :disabled="!(newFieldCost.cgcId > 0)"
                  @value-changed="onChangeCostItem"
                  />
              </div>
            </div>
            <div class="dx-field">
              <label for="serviceCompany" class="dx-field-label">Service Company</label>
              <div class="dx-field-value">
                <DxTextBox
                  v-model="newFieldCost.serviceCompany" name="serviceCompany"
                />
            </div>
            </div>
            <div class="dx-field">
              <label for="description" class="dx-field-label">Description</label>
              <div class="dx-field-value">
                <DxTextArea
                  v-model="newFieldCost.description"
                  name="description"
                  :height="90"
                  :input-attr="{ 'aria-label': 'Description' }"
                />
              </div>
            </div>
            <div class="dx-field">
              <label for="qty" class="dx-field-label">Quantity</label>
              <div class="dx-field-value">
                <DxNumberBox
                  v-model="newFieldCost.qty"
                  name="qty"
                  :min="0"
                  @value-changed="qtyChanged"
                />
              </div>
            </div>
            <div class="dx-field">
              <label for="costAmount" class="dx-field-label">Cost Amount</label>
              <div class="dx-field-value">
                <DxNumberBox
                  v-model="newFieldCost.costAmount"
                  name="costAmount"
                  :read-only="true"
                  :format="{ type: 'currency' }"
                />
              </div>
            </div>
          </div>
        </DxPopup>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxSelection,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import { 
  DxPopup, 
  DxPosition, 
  DxToolbarItem 
} from 'devextreme-vue/popup'
import DxSelectBox from 'devextreme-vue/select-box'
import DxButton from 'devextreme-vue/button'
import DxTextArea from 'devextreme-vue/text-area'
import DxTextBox from 'devextreme-vue/text-box'
import { DxNumberBox } from 'devextreme-vue/number-box'
import notify from "devextreme/ui/notify"
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'

Vue.use(VueFormGenerator)
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})
export default {
  components: {
    // ReportPicker,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxButton,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxSelectBox,
    DxTextArea,
    DxTextBox,
    DxNumberBox,
    GridButton 
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    fieldId: {
      type: Number,
      default: 0
    },
    lastSubmitId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      cbId: 0,
      selectedRows: undefined,
      costData: [],
      newFieldCost: {description: "sdafsdf"},
      optionsComboUnitSize: [],
      optionsComboContractBundle: [{text:"Select",value:0}],
      optionsComboGeneralComponent: [{text:"Select",value:0}],
      optionsComboCostItem: [{text:"Select",value:0}],
      generalComponents: [],
      costItems: [],
      deleteWarning: false,
      saveButtonOptions: {
        text: 'Save',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => {
          delete(this.newFieldCost.costPerUnit)
          this.saved(this.newFieldCost)
          /* this.newFieldCost.id = this.costData.length
          this.costData.push({...this.newFieldCost}) */
          this.popupVisible = false
        }
      },
      closeButtonOptions: {
        text: 'Close',
        stylingMode: 'outlined',
        type: 'danger',
        onClick: () => {
          this.popupVisible = false
        }
      },
      costItemData: [],
      fieldCostDataSource: null,
      costPerUnit: 1,
      costUnit: '',
      form: [],
      sumFieldCost: 0, sumFieldCostFormatted:'',
      cumFieldCost: 0, cumFieldCostFormatted:'',
      sourceSubmitId: 0,
      show: true,
      popupVisible: false,
      selectedAction: '',
      popUpTitle: '',
      reportIsLoading: false,
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    totalRows() {
      if (this.costData) return this.costData.length
      else return 0
    },
    editEligible() {
      return this.selectedRows !== undefined && this.editable
    }
  },
  watch: {
    submitId: function (value) {
      this.refreshTableCost()
    },
  },
  created: function () {
    this.refreshTableCost()
    // this.init()
    this.loadCombo()
  },
  methods: {
    ...formMethods,
    popUpForm(action) {
      if (action === 'ADD') {
        this.form = []
        
        this.selectedRow = []
        this.costPerUnit = 0
      } else if (action === 'UPDATE') {
          let cb = this.optionsComboContractBundle.find(x => x.text === this.selectedRow[0].contractBundle)
          if (cb !== undefined) {
            this.form.contractBundle = cb.value
            this.loadComboGeneralComponent(cb.value)
          }          
      }
      this.selectedAction = action
    },
    fnPopUpTitle() {
      const title = this.newFieldCost.id !== undefined ? 'Update Field Cost' : 'Add Field Cost'
      return title
    },
    init() {
      this.fieldCostDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const url = mapApiUrl('/api/form/master/cost/list-views')
          return fetch(url + `?submitId=${this.submitId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
                this.calcTotal(result)
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/cost/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/cost/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/cost/delete')
          return fetch(url + `?id=${key}&submitId=${this.submitId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
    },
    onSelectionChanged(e) {
      this.selectedRows = e.selectedRowsData
    },
    onRowClick(e) {
      if (this.selectedRows === undefined) {
        this.selectedRows = e.data
        e.component.selectRows(e.data.id)
      }
      else {
        e.component.deselectAll()
        if (this.selectedRows.id === e.data.id) {
          this.selectedRows = undefined
        } else {
          this.selectedRows = e.data
          e.component.selectRows(this.selectedRows.id)
        }
      }
    },
    addRow(e) {
      // e.preventDefault()
      this.newFieldCost = {
        qty: 0, costPerUnit:1
      }
      this.popUpTitle = 'Add Field Cost'
      this.popupVisible = true
    },
    prepareForm() {
      const rowData = this.costData.find(x => x.id === this.selectedRows.id)
      this.newFieldCost = {
        id: rowData.id,
        cbId: rowData.cbId,
        cgcId: rowData.cgcId,
        ciId: rowData.ciId,
        description: rowData.description,
        serviceCompany: rowData.serviceCompany,
        qty: rowData.qty,
        costPerUnit: rowData.costPerUnit,
        costAmount: (rowData.qty * rowData.costPerUnit)
      }
    },
    cloneRow() {
      this.prepareForm()
      delete this.newFieldCost.id
      this.popupVisible = true
      this.popUpTitle = "Add Field Cost"
    },
    editRow() {
      this.prepareForm()
      this.popUpTitle = 'Update Field Cost'
      this.popupVisible = true
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    onDelete() {
      this.deleteWarning = true
      this.delay(3000).then(() => { this.deleteWarning = false })
    },
    deleteRow() {      
      this.deleteWarning = false
      this.deleteRecord(this.selectedRows.id)
    },
    refreshTableCost() {
      this.retrieveCumWellCost()
      this.retrieveDataTable()
    },
    calcTotal(rows) {
      let sum=0
      for (const data of rows) {
        data.costAmount = data.qty * data.costPerUnit
        sum += data.costAmount
      }
      this.sumFieldCost = sum
      this.sumFieldCostFormatted = formatter.format(this.sumFieldCost)
     this.cumFieldCostFormatted = formatter.format(this.cumFieldCost + sum)
    },
    qtyChanged(e) {
      this.newFieldCost.costAmount = this.newFieldCost.qty * this.newFieldCost.costPerUnit
    },
    retrieveDataTable() {
      this.costData = []
      const url = mapApiUrl('/api/form/master/cost/list-views')
      let params={submitId: this.submitId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        if (response.data && response.data.length>0) {
          this.costData = response.data
          this.calcTotal(this.costData)
        }
      })
    },
    retrieveCumWellCost() {
      axios.get(mapApiUrl('/api/form/master/cost/get-cum-well-cost-with-exception'),
        {params: {wellId: this.wellId, submitId: this.submitId}})
        .then((response) => {
          this.cumFieldCost = response.data
        })
    },
    saved(e) {
      let rowData = e
      rowData.submitId = this.submitId
      rowData.dailyReportId = this.submitId
      delete rowData.costAmount

      if (isNaN(rowData.id)) {
        delete rowData.id
      }
      this.reportIsLoading = true
      const url = mapApiUrl('/api/form/master/cost/add')
      axios.post(url, qs.stringify(rowData)).then((response) => {
        this.reportIsLoading = false
        this.refreshTableCost()
        notify({ message: 'Field cost data has been recorded.', width: 500 }, 'success', 3000)
      })
    },
    deleteRecord(id) {
      // const isCanceled = new Promise((resolve, reject) => {
        this.reportIsLoading = true
        axios.delete(
          mapApiUrl("/api/form/master/cost/delete"),
          {params: { id: id, submitId: this.submitId }})
          .then((response) => {
            this.reportIsLoading = false
            this.refreshTableCost()
            /* if (response.data === "true") {
              resolve(true)
            } else {
              reject(new Error("Cost data row delete failed"))
            } */
          })
      // })
      // e.cancel = isCanceled
    },
    loadCombo() {
      // load combo contract bundle
      this.generalComponents=[]
      this.costItems=[]
      this.getComboListContractBundle({
        params: { field_id: this.fieldId },
      }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboContractBundle = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = { cbId: _arrData[i].cbId, text: _arrData[i].cbName }
          this.optionsComboContractBundle.push(_temp)
        }
        /*
        for (let cb of this.optionsComboContractBundle) {
          console.log("Loading "+ cb.text + " - " + cb.value)
          this.getComboListGeneralComponent({
            params: { contract_bundle_id: cb.value },
          }).then((resp) => {
            for (const gcData of resp.data.data) {
              let _temp = { value: gcData.cgcId, text: gcData.cgcName, cbId: cb.value }
              this.generalComponents.push(_temp)
            }
            for (let gc of this.generalComponents) {
              console.log("Loading "+ gc.text + " - " + gc.value)
              this.getComboListCostItem({
                params: { general_component_id: gc.value },
              }).then((resp) => {

                for (const ciData of resp.data.data) {
                  let _temp = {
                    cgcId: gc.value,
                    value: ciData.ciId,
                    text: ciData.ciName,
                    costPerUnit: ciData.costPerUnit,
                    costUnit: ciData.cuName,
                  }
                  this.costItems.push(_temp)
                }
              })
            }
          })
        } */
      })
    },
    setContractBundle(newData, value, currentRowData) {
      console.log(newData, value, currentRowData)
    },
    onChangeContractBundle(item) {
      this.newFieldCost.cbId = item.value
      this.loadComboGeneralComponent()
    },
    loadComboGeneralComponent() {
      if (this.newFieldCost.cbId === undefined) return
      this.getComboListGeneralComponent({
        params: { contract_bundle_id: this.newFieldCost.cbId },
      }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboGeneralComponent = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = { cgcId: _arrData[i].cgcId, text: _arrData[i].cgcName }
          this.optionsComboGeneralComponent.push(_temp)
        }
      })
    },
    onChangeGeneralComponent(item) {
      this.newFieldCost.cgcId = item.value
      this.loadComboCostItem()
    },
    loadComboCostItem(item) {
      if (this.newFieldCost.cgcId === undefined) return
      return this.getComboListCostItem({
        params: { general_component_id: this.newFieldCost.cgcId },
      }).then((resp) => {
        this.costItemData = resp.data.data
        this.optionsComboCostItem = []
        for (const costItem of resp.data.data) {
          let newCostItem = {
            ciId: costItem.ciId,
            text: costItem.ciName,
          }
          this.optionsComboCostItem.push(newCostItem)
        }
      })
    },
    onChangeCostItem(item) {
      this.newFieldCost.ciId = item.value
      const val = this.costItemData.find((element, index, array) => {
        return item.value === element.ciId
      })
      this.newFieldCost.costPerUnit = val !== undefined ? val.costPerUnit : 0
      this.qtyChanged()
    },
  },
}
</script>
<style>
.cell-disabled input[readonly] {
    background-color: lightgray;
    color: blue;
}  
</style>